import React, { useEffect, useState } from 'react'

import './style.scss';
import { setButtonClick, setErrorButton, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import CustomTitle from '../../components/UI/title/CustomTitle';
import GoalsContent from './GoalsContent';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';

export default function Goals() {
    const initialCheckboxState = [
        {
            id: '0',
            checked: true,
            title: 'Purchases',
            text: "Increase amount of orders",
            img: 'Shopify.svg',
        },
        {
            id: '2',
            checked: false,
            title: 'ROAS',
            text: "Boost return on<br> ad spend",
            img: 'g2.svg',
        },
        {
            id: '1',
            checked: false,
            title: 'CPA',
            text: "Lower cost per action",
            img: 'g2.svg',
        },

        {
            id: '3',
            checked: false,
            title: 'CTR',
            text: "Improve<br>click-through rate",
            img: 'g2.svg',
        }
    ];

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [disabled, setDisabled] = useState(false);
    const [checkboxes, setCheckboxes] = useState(initialCheckboxState);
    const [error, setError] = useState(false);
    const [value, setValue] = useState([]);

    useEffect(() => {
        setValue(checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.id));
    }, [checkboxes]);

    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);

    const getPriorityCheckedCheckboxId = () => {
        const checkedCheckboxes = checkboxes.filter(checkbox => checkbox.checked);
        if (checkedCheckboxes.length > 0) {
            return checkedCheckboxes[0].id;
        }
        return null;
    };

    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            if (disabled) {
                setError(true);
                dispatch(setErrorButton(true))
                dispatch(setButtonClick(false));
                setTimeout(() => {
                    setError(false);
                    dispatch(setErrorButton(false))
                }, 2000);
                return;
            }
            dispatch(setButtonClick(false));
            queryParams.set('goals', getPriorityCheckedCheckboxId());
            queryParams.set('goals-value', value);
            queryParams.set('goals-text',

                checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.title).join(', ')
            );
            trackP1Event('onboarding_ad_goals', {
                goals: checkboxes.filter(checkbox => checkbox.checked).map(checkbox => checkbox.title).join(', ')
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`,
            });

        }
    }, [buttonClicked, dispatch, disabled, checkboxes]);


    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Let’s achive your goal'));
        dispatch(setIconButton(''));
    }, []);


    return (
        <div className="goals page">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={'What’s your top priority for improving sales?'}
                    />
                    <div className="goals-wrapper">
                        <GoalsContent setError={setError} checkboxes={checkboxes} setCheckboxes={setCheckboxes} error={error} setDisabled={setDisabled} />
                    </div>
                </div>
            </PageContent>

        </div>
    )
}
